import * as React from 'react'
import { Tooltip, Icon } from '@material-ui/core'
import { TooltipProps } from '@material-ui/core/Tooltip'
import { css } from 'src/conf/style'

const LabelTooltip = (props: {label: string, tooltip: React.ReactNode, position?: TooltipProps["placement"], icon?: string}) => (
    <Tooltip title={props.tooltip} placement={props.position ? props.position : "top-start"}>
        <span style={{...css.flexAlCenter}}>
            {props.label}
            {props.icon &&
                <Icon style={{fontSize: '18px', color: '#9e9e9e', marginLeft: '4px'}}>{props.icon}</Icon>
            }
        </span>
    </Tooltip>
)

export default LabelTooltip;


// WEBPACK FOOTER //
// ./src/shared/LabelTooltip/LabelTooltip.tsx